<template>
    <Dialog
        :value="showDialog"
        :header-text="title"
        persistent
        fixed
        full-content-width
        :width="920"
        @close_modal="$emit('close')"
    >
        <template #topBar>
            <NoteTabs
                :note-topics="note_topics"
                :active-tab="activeTab"
                @change="changeActiveTab($event)"
            />
        </template>
        <div class="d-none">
            <input
                ref="files_input"
                type="file"
                multiple
                @change="handleFilesUpload()"
            />
        </div>
        <NoteEditView
            ref="noteEditView"
            :edit-note="editNote"
            :comments="comments"
            :handle-files-upload="handleFilesUpload"
            @change="comments = $event"
        />
        <template #footer>
            <NoteFooter
                :files="files"
                :uploaded-files="uploaded_files"
                :remove-file="removeFile"
                :remove-uploaded-file="removeUploadedFile"
                :add-link="addLink"
                :add-files="addFiles"
                :save-note-click="saveNoteClick"
                :loader="loader"
                :edit-note="editNote"
                :toggle-is-pinned="toggleIsPinned"
                :is-pinned="isPinned"
            />
        </template>
    </Dialog>
</template>

<script>
import Dialog from "../../components/Dialog.vue";
import { computed, ref, onMounted, nextTick } from "@vue/composition-api";
import { $t } from "@/i18n";
import NoteEditView from "./NoteEditView";
import NoteFooter from "@/views/Note/NoteFooter.vue";
import UseNoteEdit from "@/composables/NoteEdit";
import NoteTabs from "@/views/Note/NoteTabs.vue";

export default {
    name: "NoteDialog",
    components: {
        NoteTabs,
        Dialog,
        NoteEditView,
        NoteFooter
    },
    props: {
        showDialog: {
            type: Boolean,
            required: true
        },
        note: {
            type: Object,
            required: true
        },
        forcedActiveTabType: {
            type: String,
            default: "info"
        }
    },
    setup(props, ctx) {
        const files_input = ref(null)
        const noteEditView = ref(null)

        const noteChanged = note => {
            ctx.emit("change", note);
            ctx.emit("close");
        };

        const richTextEditor = computed(() => {
            return noteEditView.value.$refs.richTextEditor
        })

        const changeActiveTab = (value) => {
            activeTab.value = value
            setFocus()
        }

        const setFocus = () => {
            noteEditView.value.$refs.richTextEditor.$refs.richTextEditorContent.$el.querySelector(".ql-editor").focus()
        }

        onMounted(async () => {
            setTimeout(function() {
                setFocus()
            }, 300);
        });

        const {
            files,
            uploaded_files,
            removeFile,
            removeUploadedFile,
            addLink,
            addFiles,
            saveNoteClick,
            loader,
            editNote,
            activeTab,
            note_topics,
            comments,
            handleFilesUpload,
            toggleIsPinned,
            isPinned,
        } = UseNoteEdit(props.note.related_type, props.note.related_id, props.note, noteChanged, files_input, richTextEditor)

        const title = computed(function () {
            return props.note.id ? $t('Edit note') : $t('Add note');
        });

        activeTab.value = note_topics.value.findIndex((x) => x.value === props.forcedActiveTabType)

        return {
            title,
            noteChanged,
            files,
            uploaded_files,
            removeFile,
            removeUploadedFile,
            addLink,
            addFiles,
            saveNoteClick,
            loader,
            editNote,
            activeTab,
            note_topics,
            comments,
            handleFilesUpload,
            files_input,
            noteEditView,
            toggleIsPinned,
            isPinned,
            changeActiveTab,
        };
    }
};
</script>

<style scoped lang="scss">
::v-deep .quill-editor {
    .ql-container {
        .ql-editor {
            min-height: 300px;
            height: unset !important;
        }
    }
}
</style>